//CONSTANT
import { GET_APP_NAME_FOR_COLLECTION } from "../../app_constant";

//CONTENT
import { GET_LOCAL_QUESTIONS } from "./content";

//PACKAGES
import { auth, firestore } from "./config";
import { getEffectiveUid } from "./ghostUid";
import posthog from "posthog-js";
import _ from "lodash";
import moment from "moment";

const collection = async () => {
  const APP_NAME = await GET_APP_NAME_FOR_COLLECTION();
  return firestore()
    .collection("apps")
    .doc(APP_NAME)
    .collection("users")
    .doc(getEffectiveUid());
};

async function SAVE_QUESTION_BOOKMARK(data) {
  return saveUserField("question_bookmarks", data);
}

async function UPLOAD_QUESTION() {
  const QUESTIONS = GET_LOCAL_QUESTIONS();
  for (let index in QUESTIONS) {
    let question = QUESTIONS[index];
    try {
      const APP_NAME = await GET_APP_NAME_FOR_COLLECTION();
      firestore()
        .collection("apps")
        .doc(APP_NAME)
        .collection("questions")
        .doc()
        .set(question);
    } catch (e) {
      console.error(e);
    }
  }
}

// Transient Firestore error codes worth retrying; auth/permission/not-found are not.
const _USER_FIELD_TRANSIENT_CODES = new Set([
  "unavailable",
  "deadline-exceeded",
  "aborted",
  "internal",
  "resource-exhausted", // quota/contention under heavy use — genuinely retryable
  "cancelled",
]);

// Single durable writer for top-level user-doc fields: set+merge (upsert-safe,
// only touches `field`), bounded retry on transient errors, and a *reported*
// (not swallowed) final failure. Replaces the lossy .update()+swallow+no-retry
// pattern that left questions_progress / bookmarks / scores frozen (B-10).
async function saveUserField(field, data) {
  let collection_user;
  let lastErr;
  for (let attempt = 0; attempt < 3; attempt++) {
    try {
      // The DocumentReference is invariant across attempts — resolve it once.
      if (!collection_user) collection_user = await collection();
      await collection_user.set({ [field]: data }, { merge: true });
      return { status: true, error: "" };
    } catch (error) {
      lastErr = error;
      if (!_USER_FIELD_TRANSIENT_CODES.has(error?.code)) break;
      if (attempt < 2) await new Promise(r => setTimeout(r, 300 * Math.pow(2, attempt)));
    }
  }
  // Report via the posthog-js singleton (initialized by <PostHogProvider apiKey=…>
  // in App.js); `window.posthog` is never set by the npm bundle, so don't use it.
  try {
    posthog?.captureException(
      lastErr instanceof Error ? lastErr : new Error(String(lastErr?.message || lastErr)),
      { context: "saveUserField", field, code: lastErr?.code }
    );
  } catch (_) {}
  return { status: false, error: lastErr?.message || "save failed" };
}

async function SAVE_QUESTION_PROGRESS(data) {
  return saveUserField("questions_progress", data);
}

async function GET_SCORE_QUESTIONS() {
  //console.log("GET_SCORE_QUESTIONS");
  //console.log("NODE_ENV", process.env.NODE_ENV);
  try {
    const APP_NAME = await GET_APP_NAME_FOR_COLLECTION();
    const result = await firestore()
      .collection("apps")
      .doc(APP_NAME)
      .collection("users")
      .doc(getEffectiveUid())
      .collection("questions")
      .get();
      console.log('>>>>>>>>>>>>>>>>>>>>>>> GET_APP_NAME_FOR_COLLECTION APP_NAME', APP_NAME);
      console.log('>>>>>>>>>>>>>>>>>>>>>>> GET_APP_NAME_FOR_COLLECTION getEffectiveUid()', getEffectiveUid());
      console.log('>>>>>>>>>>>>>>>>>>>>>>> GET_APP_NAME_FOR_COLLECTION result', result);
      
    var list = [];
    result.forEach((documentSnapshot) => {
      console.log('>>>>>>>>>>>>>>>>>>>>>>>>> documentSnapshot', documentSnapshot);
      
      var data = documentSnapshot.data();
      data.documentID = documentSnapshot.id;
      list.push(data);
    });
    console.log('>>>>>>>>>>>>>> GET_SCORE_QUESTIONS APP_NAME', APP_NAME);
    console.log('>>>>>>>>>>>>>> GET_SCORE_QUESTIONS result', result);
    
    return { status: true, data: list, error: "", isExist: list.length > 0 };
  } catch (error) {
    return { status: false, data: [], error: error.message };
  }
}

async function SAVE_QUESTION(data) {
  console.log('>>>>>>>>>>>>>> SAVE_QUESTION data', data);
  try {
    // Persist topic_id as a number even if a replayed test-history record carried it as a string,
    // so stored score records stay type-consistent (B-13). Only numeric strings are coerced.
    if (typeof data?.topic_id === 'string' && data.topic_id.trim() !== '' && Number.isFinite(Number(data.topic_id))) {
      data = { ...data, topic_id: Number(data.topic_id) };
    }
    const APP_NAME = await GET_APP_NAME_FOR_COLLECTION();
    const result = await firestore()
      .collection("apps")
      .doc(APP_NAME)
      .collection("users")
      .doc(getEffectiveUid())
      .collection("questions")
      .doc(data.question_id.toString())
      .get();
    if (result.exists) {
      await firestore()
        .collection("apps")
        .doc(APP_NAME)
        .collection("users")
        .doc(getEffectiveUid())
        .collection("questions")
        .doc(data.question_id.toString())
        .update(data);
    } else {
      await firestore()
        .collection("apps")
        .doc(APP_NAME)
        .collection("users")
        .doc(getEffectiveUid())
        .collection("questions")
        .doc(data.question_id.toString())
        .set(data);
      return { status: true, error: "" };
    }
  } catch (error) {
    return { status: false, error: error.message };
  }
}

// Apply a readiness-recalc migration ATOMICALLY: write the migrated score records and delete
// the orphans in chunked WriteBatches (Firestore caps a batch at 500 ops). This is the only
// path that deletes score docs in bulk, so atomicity matters — a partial failure must not
// leave the user half-migrated while the UI claims success. Returns { status, error }.
async function MIGRATE_QUESTION_SCORES(scoresToSave = [], deletedQuestionIds = []) {
  try {
    const APP_NAME = await GET_APP_NAME_FOR_COLLECTION();
    const base = firestore()
      .collection("apps")
      .doc(APP_NAME)
      .collection("users")
      .doc(getEffectiveUid())
      .collection("questions");

    // Strip undefined values (Firestore rejects them; this config doesn't set
    // ignoreUndefinedProperties) — mirrors SAVE_QUESTION's hardening and the mobile path.
    const clean = (data) =>
      Object.keys(data).reduce((acc, key) => {
        if (data[key] !== undefined) acc[key] = data[key];
        return acc;
      }, {});

    const ops = [
      ...scoresToSave.map((s) => ({ type: "set", id: String(s.question_id), data: clean(s) })),
      ...deletedQuestionIds
        .filter((id) => id !== undefined && id !== null)
        .map((id) => ({ type: "delete", id: String(id) })),
    ];

    const BATCH_LIMIT = 500;
    for (let i = 0; i < ops.length; i += BATCH_LIMIT) {
      const batch = firestore().batch();
      ops.slice(i, i + BATCH_LIMIT).forEach((op) => {
        const ref = base.doc(op.id);
        if (op.type === "set") batch.set(ref, op.data, { merge: true });
        else batch.delete(ref);
      });
      await batch.commit();
    }
    return { status: true, error: "" };
  } catch (error) {
    return { status: false, error: error.message };
  }
}

async function RESET_USER_QUESTIONS_COLLECTION() {
  try {
    const APP_NAME = await GET_APP_NAME_FOR_COLLECTION();
    const result = await firestore()
      .collection("apps")
      .doc(APP_NAME)
      .collection("users")
      .doc(getEffectiveUid())
      .collection("questions")
      .get();
    // Firestore caps a WriteBatch at 500 operations, so delete in chunks
    // and await each commit so failures surface to the caller.
    const BATCH_LIMIT = 500;
    const docs = result.docs;
    for (let i = 0; i < docs.length; i += BATCH_LIMIT) {
      const batch = firestore().batch();
      docs.slice(i, i + BATCH_LIMIT).forEach((documentSnapshot) => {
        batch.delete(documentSnapshot.ref);
      });
      await batch.commit();
    }

    return { status: true, error: "" };
  } catch (error) {
    return { status: false, error: error.message };
  }
}

async function SAVE_SCORE_PROGRESS(data) {
  return saveUserField("score_progress", data);
}

async function SAVE_PROGRESS_DASHBOARD(data) {
  return saveUserField("readiness_scores", data);
}



export {
  SAVE_QUESTION_BOOKMARK,
  SAVE_QUESTION_PROGRESS,
  // SAVE_QUESTION_SCROE,
  SAVE_PROGRESS_DASHBOARD,
  SAVE_SCORE_PROGRESS,
  UPLOAD_QUESTION,
  SAVE_QUESTION,
  MIGRATE_QUESTION_SCORES,
  GET_SCORE_QUESTIONS,
  RESET_USER_QUESTIONS_COLLECTION
};
